import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import * as Sentry from '@sentry/vue';
import { createSentryPiniaPlugin } from '@sentry/vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import { createApp } from 'vue';
import App from '@/App.vue';
import { HttpVisualizationAgentClient } from '@/features/ai-visualization/services/HttpVisualizationAgentClient.ts';
import {
  visualizationAgentClientKey,
} from '@/features/ai-visualization/services/index.ts';
import router from '@/router';
import { installResourceUpdates } from '@/utils/resourceUpdates';
import { ensureAppViewportMeta } from '@/utils/viewportMeta';
import '@/assets/index.css';

ensureAppViewportMeta(document);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
const visualizationAgentClient = new HttpVisualizationAgentClient();

app.provide(visualizationAgentClientKey, visualizationAgentClient);

const sentryEnabled = import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === 'true';
if (sentryEnabled) {
  pinia.use(createSentryPiniaPlugin());
  Sentry.init({
    app,
    environment: import.meta.env.MODE,
    dsn: import.meta.env.VITE_SENTRY_DSN
      || 'https://c6ea61722ebb8f94213cd0f5ec0a3763@sentry.umaster.top/3',
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.replayCanvasIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    normalizeDepth: 10,
  });
}

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.600}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
  },
});

app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: MyPreset,
    options: {
      prefix: 'p',
      darkModeSelector: 'none',
      cssLayer: false,
    },
  },
});
app.use(autoAnimatePlugin);
app.use(ToastService);
app.use(pinia);
app.use(router);
app.mount('#app');
installResourceUpdates();
